<div [ngClass]="{
    'pdf-landscape': isLandscape,
    'pdf-portrait': isPortrait
  }">

  <div class="pdf-scroll-container">

    <!-- Contenedor externo -->
    <div class="container-externo">

      <!-- 🔹 Toolbar de áreas predefinidas -->
      <div class="signature-toolbar d-flex align-items-center flex-wrap justify-content-between gap-2 mb-2"
        *ngIf="!read_only && !usa_plantilla">

        <!-- Bloque izquierdo -->
        <div class="d-flex flex-wrap align-items-center gap-2" data-tour="selector-tamanios-firmas">

          <label class="mb-0 fw-semibold me-2 toolbar-title">
            Área de firma:
          </label>

          <!-- Dropdown -->
          <div class="dropdown signature-size-dropdown" *ngIf="predefinedAreas?.length">

            <button class="btn btn-outline-primary btn-sm dropdown-toggle d-flex align-items-center gap-2" type="button"
              id="dropdownSignatureSizes" data-bs-toggle="dropdown" aria-expanded="false">

              <span *ngIf="selectedTemplateId" class="check-icon">
                ✔
              </span>

              <span>
                {{ selectedTemplateLabel }}
              </span>

            </button>

            <ul class="dropdown-menu signature-size-menu" aria-labelledby="dropdownSignatureSizes">

              <!-- Buscador -->
              <li class="px-3 pt-2 pb-2">

                <input type="text" class="form-control form-control-sm" placeholder="Buscar tamaño..."
                  [(ngModel)]="searchSizeTerm">

              </li>

              <li>
                <hr class="dropdown-divider">
              </li>

              <!-- Lista -->
              <li *ngFor="let tpl of filteredPredefinedAreas">

                <button class="dropdown-item" [ngClass]="tpl.id === selectedTemplateId
                    ? 'active-dropdown-item'
                    : ''" (click)="selectTemplate(tpl)">

                  {{ tpl.nombre }}

                </button>

              </li>

              <!-- Vacío -->
              <li *ngIf="filteredPredefinedAreas.length === 0" class="px-3 py-2 text-muted small">

                Sin resultados

              </li>

            </ul>

          </div>

        </div>

        <!-- Switch -->
        <div class="form-check form-switch ms-md-3 toolbar-switch" data-tour="selector-modo-seleccion">

          <input class="form-check-input" type="checkbox" id="usePredefinedAreas" [(ngModel)]="usePredefinedAreas">

          <label class="form-check-label" for="usePredefinedAreas">

            Arrastrar área fija

          </label>

        </div>

      </div>

      <!-- PDF -->
      <pdf-viewer *ngIf="url_document" [src]="url_document" [render-text]="true" [zoom]="zoom" [original-size]="false"
        [fit-to-page]="true" [show-all]="true" [autoresize]="true" (after-load-complete)="onPdfLoaded($event)"
        (page-rendered)="attachPageOverlay()" class="pdf-viewer-frame" [ngClass]="{'pdf-landscape': isLandscape}">

      </pdf-viewer>

    </div>

    <div *ngIf="!url_document" class="text-center p-4">

      Cargando documento o no hay documento para mostrar...

    </div>

  </div>
  <!-- ========================================= -->
  <!-- 🔥 CONTROLES DEBAJO DEL VISOR -->
  <!-- ========================================= -->

  <div class="bottom-controls-container" *ngIf="isDiviceType">

    <!-- ZOOM -->
    <div class="mobile-zoom-toolbar">

      <button class="toolbar-btn" (click)="zoomOut()">

        <i class="fa-solid fa-minus"></i>

      </button>

      <button class="toolbar-zoom-value" (click)="resetZoom()">

        {{ zoom | number:'1.0-1' }}x

      </button>

      <button class="toolbar-btn" (click)="zoomIn()">

        <i class="fa-solid fa-plus"></i>

      </button>

    </div>

    <!-- TOGGLE -->
    <div class="toggle-control" *ngIf="!read_only">

      <button class="action-button" [ngClass]="{'is-edit-mode': !isEditMode}" (click)="toggleMode()">

        <span class="icon">

          <i class="fa-solid" [ngClass]="isEditMode
                  ? 'fa-arrows-up-down-left-right'
                  : 'fa-pen'">

          </i>

        </span>

      </button>

    </div>

  </div>
</div>

<!-- MODAL -->
<ng-template #modalFileViewer let-modal>

  <div class="modal-header">

    <p class="modal-title" id="modal-basic-title" style="font-size: 1.8em;">

      Asignar Firmante

    </p>

    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">

    </button>

  </div>

  <div class="modal-body">

    <select id="select_firmante" [(ngModel)]="firmanteSeleccionado" class="signer-input form-control"
      (ngModelChange)="firmante($event)" *ngIf="modulo != 'Plantilla'">

      <option value="">
        Seleccione un firmante
      </option>

      <option *ngFor="let crt of certificado" [ngValue]="crt">

        {{ crt.name }}

      </option>

    </select>

    <input type="text" class="form-control" name="descripcion" id="descripcion_plantilla"
      [(ngModel)]="currentSignerName" *ngIf="modulo == 'Plantilla'">

  </div>

  <div class="modal-footer">

    <button (click)="confirmSigner()" class="btn btn-success" *ngIf="existFirmante && modulo != 'Plantilla'">

      Confirmar

    </button>

    <button (click)="confirmSigner()" class="btn btn-success" *ngIf="modulo == 'Plantilla'">

      Confirmar

    </button>

    <button (click)="cancelSigner()" class="btn btn-danger">

      Cancelar

    </button>

  </div>

</ng-template>